import React, { useState, useEffect } from 'react';
import { usePeriodosLazyQuery } from '../graphql/queries/periodos.query';
import { PeriodosPageQuery_periodos } from '../graphql/queries/__generated__/PeriodosPageQuery';
import { useCadastrarPeriodoMutation } from '../graphql/mutations/cadastrar_periodo.mutation';
import { useDeletarPeriodoMutation } from '../graphql/mutations/deletar_periodo.mutation';
import { useEditarPeriodoMutation } from '../graphql/mutations/editar_periodo.mutation';
import { FormPeriodo, FormularioPeriodo } from '../components/form_periodo';
import { FormList } from '../../shared/components/form_components/list';
import { Container } from '../../shared/components/layout_components/container/styles';
import { DateTime } from 'luxon';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';

const PeriodoPage: React.FC = () => {
  const [periodo, setPeriodo] = useState<FormPeriodo>();
  const [periodos, setPeriodos] = useState<PeriodosPageQuery_periodos[]>([]);
  const itens_por_pagina = 25;

  const [obter_periodos, { fetchMore, loading }] = usePeriodosLazyQuery();
  const [cadastar_periodo] = useCadastrarPeriodoMutation();
  const [editar_periodo] = useEditarPeriodoMutation();
  const [deletar_periodo] = useDeletarPeriodoMutation();

  const on_submit = async (periodo: FormPeriodo) => {
    if (!periodo.id_periodo) {
      const { data } = await cadastar_periodo({
        variables: {
          ...periodo,
        },
      });

      if (data) {
        setPeriodos([...periodos, data.cadastrarPeriodo]);

        alert('Período cadastrado com sucesso!');
      }
    } else {
      const { data } = await editar_periodo({
        variables: {
          ...periodo,
          id_periodo: periodo.id_periodo,
        },
      });

      if (data) {
        const index = periodos.findIndex((item) => item.id_periodo === periodo.id_periodo);

        if (index !== -1) {
          const periodos_atualizados = [...periodos];
          periodos_atualizados[index] = data.editarPeriodo;
          setPeriodos(periodos_atualizados);
        }

        alert('Período editado com sucesso!');
      }
    }

    setPeriodo(undefined);
  };

  const on_edit = (periodo: PeriodosPageQuery_periodos) => {
    setPeriodo({
      id_periodo: periodo.id_periodo,
      dsc_periodo: periodo.dsc_periodo,
      dat_inicio: DateTime.fromISO(periodo.dat_inicio, { setZone: true }).toFormat('yyyy-MM-dd'),
      dat_fim: DateTime.fromISO(periodo.dat_fim, { setZone: true }).toFormat('yyyy-MM-dd'),
    });
  };

  const on_delete = async (id_periodo: number) => {
    await deletar_periodo({ variables: { id_periodo } });
    setPeriodos((periodos) => periodos.filter((h) => h.id_periodo !== id_periodo));
  };

  const on_cancel_edit = () => {
    setPeriodo(undefined);
  };

  const on_search = async (search: string) => {
    const { data } = await fetchMore({
      variables: {
        descricao: search,
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setPeriodos(data.periodos);
    }
  };

  const dados_dados_iniciais = async () => {
    const { data } = await obter_periodos({
      variables: {
        descricao: '',
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setPeriodos(data.periodos);
    }
  };

  useEffect(() => {
    document.title = 'SisIEC - Períodos';
    dados_dados_iniciais();
  }, []);

  return (
    <Container>
      <SubContainer flex={1}>
        <FormularioPeriodo onSubmit={on_submit} onCancel={on_cancel_edit} periodo={periodo} />
      </SubContainer>

      <SubContainer flex={2}>
        <FormList
          list_name='Períodos'
          items={periodos.map((p) => ({
            data: p,
            id: p.id_periodo,
            label:
              p.dsc_periodo +
              ' - ' +
              DateTime.fromISO(p.dat_inicio, { setZone: true }).toFormat('dd/MM/yyyy') +
              ' até ' +
              DateTime.fromISO(p.dat_fim, { setZone: true }).toFormat('dd/MM/yyyy'),
          }))}
          onSearch={on_search}
          onEdit={on_edit}
          onDelete={on_delete}
          loading={loading}
        />
      </SubContainer>
    </Container>
  );
};

export { PeriodoPage };
